import { Middleware } from 'openapi-fetch';

export interface ClientIdState {
  clientId: string | null;
}

export interface ClientIdMiddlewareHooks {
  /** Use this to explicitly set the ID. */
  setClientId: (ID: string) => void;
  /** Use this to get the current ID. */
  getClientId: () => string | null;
  /** Use this to clear the current ID. */
  clearClientId: () => void;
}

export interface ClientIdMiddlewareResponse extends ClientIdMiddlewareHooks {
  middleware: Middleware;
}

export function makeClientIdMiddleware(
  clientId: null | string = null,
): ClientIdMiddlewareResponse {
  const clientIdState: ClientIdState = { clientId };

  const middleware: Middleware = {
    onRequest: async ({ request }) => {
      if (clientIdState.clientId) {
        const extraBody = { clientId: clientIdState.clientId };

        if (request.headers.get('Content-Type') === 'application/json') {
          const original = await request.json();
          request = new Request(request, {
            body: JSON.stringify({ ...original, ...extraBody }),
          });
        } else if (request.headers.get('Content-Type') === null) {
          request = new Request(request, { body: JSON.stringify(extraBody) });
          request.headers.set('Content-Type', 'application/json');
        }
      }

      return request;
    },
  };

  return {
    middleware: middleware,
    setClientId: (clientId: string) => (clientIdState.clientId = clientId),
    getClientId: () => clientIdState.clientId,
    clearClientId: () => (clientIdState.clientId = null),
  };
}
